<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="empresas" v-model="empresaSelecionada" item-text="razao_social"
                            item-value="id_empresa" :label="$t('routs.headers.company')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <MultiplaEscolha lazy get-url="getVeiculoslazy"
                            v-bind:selected-items.sync="veiculosSelecionados"
                            text="cod_veiculo" value="id_veiculo" :label="$t('nav.registration.vehicles')"
                            :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha lazy get-url="getLinhaslazy"
                            v-bind:selected-items.sync="linhasSelecionadas"
                            text="nome_linha" value="id_linha" :label="$t('nav.registration.lines')" :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha lazy get-url="getUnidadeslazy" :items="semUnidadeOption"
                            v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade" value="id_unidade" :label="$t('nav.registration.units')"
                            :max-items="2" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker :label="$t('relPontualidade.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :date-picker-props="dtiProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker :label="$t('relPontualidade.endDate')" v-model="dtf"
                            :time-picker-props="timeProps" :date-picker-props="dtfProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    :loading="loading" :disabled="loading"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <v-card v-if="buscou" class="elevation-7" style="border-radius: 10px; margin-top: 10px; margin-bottom: 10px;">
            <v-tabs v-model="tab" @change="onChangeSecao">
                <v-tab>{{ $t('relPontualidade.tabs.vehicle') }}</v-tab>
                <v-tab>{{ $t('relPontualidade.tabs.line') }}</v-tab>
                <v-tab>{{ $t('relPontualidade.tabs.unit') }}</v-tab>
                <v-tab>{{ $t('relPontualidade.tabs.company') }}</v-tab>
                <v-tab>{{ $t('relPontualidade.tabs.client') }}</v-tab>
            </v-tabs>
            <MerusDataTable :key="grupoAtual" :headers="headersAgregadoDefault" :items="itensAgregado" :search="searchAgregado"
                :loading="loading" :default-multi-sort="defaultSortAgregado"
                :loading-text="$t('relPontualidade.loading')"
                item-key="id_agregado" flat>
                <template v-slot:toolbar>
                    <CadastroToolbar :title="tituloAgregado" :token="token" :items="itensAgregado"
                        :csv-title="csvTitleAgregado" :csv-headers="headersAgregadoDefault"
                        list-endpoint="getrelatoriopontualidade" :request-params="relatorioRequestParamsAgregado"
                        :export-total="itensAgregado.length"
                        id-field="id_agregado"
                        :pdf-title="tituloAgregado" :pdf-headers="headersAgregadoDefault"
                        :pdf-filename="csvTitleAgregado" @search="searchAgregado = $event">
                    </CadastroToolbar>
                </template>
                <template v-slot:item.percentual_pontualidade="{ item }">
                    <PercentItem :value="item.percentual_pontualidade" />
                </template>
                <template v-slot:item.descricao_unidade="{ item }">
                    {{ item.descricao_unidade || $t('relPontualidade.noUnit') }}
                </template>
            </MerusDataTable>
        </v-card>
    </v-container>
</template>
<script>

import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import MerusDataTable from "../components/Tables/MerusDataTable.vue";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import PercentItem from './PercentItem.vue';

const GRUPOS = ['veiculo', 'linha', 'unidade', 'empresa', 'cliente'];
const GRUPO_TAB_KEYS = {
    veiculo: 'vehicle',
    linha: 'line',
    unidade: 'unit',
    empresa: 'company',
    cliente: 'client',
};

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar,
        PercentItem,
    },
    data: () => ({
        user: null,
        token: null,
        config: null,
        formValidado: false,
        empresas: [],
        empresaSelecionada: null,
        veiculosSelecionados: [],
        linhasSelecionadas: [],
        unidadesSelecionadas: [],
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        itensAgregado: [],
        tab: 0,
        searchAgregado: "",
        loading: false,
        buscou: false,
        cargaId: 0,
    }),
    computed: {
        grupoAtual() {
            return GRUPOS[this.tab] || 'veiculo';
        },
        csvTitleAgregado() {
            return `pontualidade_${this.grupoAtual}`;
        },
        tituloAgregado() {
            const tabKey = GRUPO_TAB_KEYS[this.grupoAtual] || 'vehicle';
            return this.$t(`relPontualidade.tabs.${tabKey}`);
        },
        semUnidadeOption() {
            return [
                {
                    id_unidade: -1,
                    descricao_unidade: this.$t('relPontualidade.noUnit'),
                    cod_unidade: 'SU',
                },
            ];
        },
        defaultSortAgregado() {
            return [
                { value: 'percentual_pontualidade', options: { text: this.$t('routs.decreasing'), value: -1 } },
            ];
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            };
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            };
        },
        headersAgregadoDefault() {
            const col = (key, value) => ({
                text: this.$t(`relPontualidade.headers.${key}`),
                value,
                sortable: true,
                filtrable: true,
                show: true,
                translation_key: `relPontualidade.headers.${key}`,
            });
            const metricas = [
                col('trips', 'n_viagens'),
                col('punctuality', 'percentual_pontualidade'),
            ];
            if (this.grupoAtual === 'veiculo') {
                return [col('vehicle', 'numero_ordem'), ...metricas];
            }
            if (this.grupoAtual === 'linha') {
                return [col('lineCode', 'cod_linha'), col('lineName', 'nome_linha'), ...metricas];
            }
            if (this.grupoAtual === 'unidade') {
                return [col('unit', 'descricao_unidade'), ...metricas];
            }
            if (this.grupoAtual === 'empresa') {
                return [col('company', 'razao_social'), ...metricas];
            }
            return [col('client', 'nome_cliente'), ...metricas];
        },
        relatorioRequestParams() {
            if (!this.dti || !this.dtf) return {};
            return {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf),
                id_empresa: this.empresaSelecionada || null,
                id_linhas: this.linhasSelecionadas.length ? this.linhasSelecionadas : null,
                id_veiculos: this.veiculosSelecionados.length ? this.veiculosSelecionados : null,
                id_unidades: this.unidadesSelecionadas.length ? this.unidadesSelecionadas : null,
            };
        },
        relatorioRequestParamsAgregado() {
            return {
                ...this.relatorioRequestParams,
                grupo: this.grupoAtual,
            };
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {
        initialize() {
            this.getConfig();
            this.populaEmpresas();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                },
            });
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
            });
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (!this.dti || !this.dtf) {
                return;
            }
            this.buscou = true;
            this.carregaGrupo(this.grupoAtual);
        },
        onChangeSecao(tabIndex) {
            this.searchAgregado = "";
            if (this.buscou) {
                this.carregaGrupo(GRUPOS[tabIndex] || this.grupoAtual);
            }
        },
        carregaGrupo(grupo) {
            if (!grupo || !this.dti || !this.dtf) {
                return;
            }

            const cargaId = this.cargaId + 1;
            this.cargaId = cargaId;
            this.loading = true;
            this.itensAgregado = [];

            apiController.request(apiController.endpoints.getRelatoriopontualidade, {
                data: { ...this.relatorioRequestParams, grupo },
                onSuccess: (response) => {
                    if (cargaId !== this.cargaId) {
                        return;
                    }
                    this.itensAgregado = response.data || [];
                    this.loading = false;
                },
                onError: () => {
                    if (cargaId !== this.cargaId) {
                        return;
                    }
                    this.loading = false;
                },
            });
        },
    },
};
</script>
<style lang="">

</style>
